import { Component, computed, inject, input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { ShoppingCartService } from '../../../services/shopping-cart/shopping-cart.service';
import { IShoppingCart } from '../../../models/shopping-cart/i-shopping-cart';
import { isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-shopping-cart',
  imports: [
    FontAwesomeModule,
    OverlayBadgeModule,
    RouterModule,
    BadgeModule,
  ],
  templateUrl: './shopping-cart.component.html',
  styleUrl: './shopping-cart.component.scss'
})
export class ShoppingCartComponent implements OnInit {
  private readonly cartService = inject(ShoppingCartService);
  private readonly platformId = inject(PLATFORM_ID);
  
  public readonly auctionId = input.required<number>();
  public useSmallIcon = input(false);
  public useExtendedDisplay = input(false);

  protected cart = signal<IShoppingCart>(this.cartService.getEmptyCart());
  protected isCartOpen = signal(false);

  protected icons = {
    faShoppingCart: faShoppingCart,
  }

  public ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.cartService.cart.subscribe(cart => this.cart.set(cart));
      this.cart.set(this.cartService.getActiveCart(this.auctionId()));
    }
  }

  protected elementsInCart = computed(() => this.cart().lineItems.length);
  protected showCount = computed(() => this.elementsInCart() > 0);
  protected iconClass = computed(() => this.useSmallIcon() ? '' : 'fa-xl');

  protected toggleCartDisplay() {
    this.isCartOpen.set(!this.isCartOpen());
  }
}
